jQuery(($) => {
  $.fn.getPage = function () {
    var page = 1;

    if ($(this).hasClass('next page-numbers')) {
      page++;
    } else if ($(this).hasClass('prev page-numbers')) {
      page--;
    } else if ($(this).hasClass('page-numbers')) {
      page = parseInt($(this).text());
    }

    return page;
  };

  if ($('.o-posts-cards-block--has-ajax')[0]) {
    function fetch_blog_posts(page) {
      var categoryName = $('.m-dropdown-filters-block__dropdown').find('.m-field__dropdown').val(),
        searchValue = $('.m-dropdown-filters-block__input').find('.m-field__input').val();

      $('.o-posts-cards-block').addClass('o-posts-cards-block--loading');

      $.ajax({
        type: 'POST',
        url: AJAX.url,
        data: {
          action: 'load_filtered_posts',
          category_name: categoryName,
          search_value: searchValue,
          page: page,
        },
        dataType: 'json',
        beforeSend: function () {
          AjaxRunning++;
        },
        success: function (result) {
          if (result.data.feed) {
            $('.o-posts-cards-block').html(result.data.feed);
            $('.o-posts-cards-block').removeClass('o-posts-cards-block--loading');
          }

          if (result.data.url) {
            window.history.pushState(
              {
                feed: result.data.feed,
              },
              {},
              result.data.url
            );
          }

          const y = document.querySelector('.o-posts-cards-block').getBoundingClientRect().top + window.pageYOffset + -180;
          window.scrollTo({ top: y, behavior: 'smooth' });

          $(window).trigger('ajax');
        },
        complete: function () {
          AjaxRunning--;
        },
      });
    }

    var AjaxRunning = 0;

    $(window).on('load ajax', function () {
      if ($('.m-dropdown-filters-block__form')[0]) {
        $('.m-dropdown-filters-block__dropdown')
          .find('.m-field__dropdown')
          .change(function () {
            fetch_blog_posts();
          });
        $('.m-dropdown-filters-block__form').submit(function (e) {
          e.preventDefault();
          fetch_blog_posts();
        });
      }

      $('.m-pagination .page-numbers').click(function (e) {
        e.preventDefault();

        var page = $(this).getPage();

        fetch_blog_posts(page);
      });
    });

    $(window).on('popstate', function (e) {
      if (e.originalEvent.state !== null) {
        if (e.originalEvent.state.feed) {
          $('.o-posts-cards-block').html(e.originalEvent.state.feed);
        }
      }
    });
  }
});